import Footer from "../../footer/Footer";
import "./Archetypes.scss";
import leftarrowblack from "../../../assets/images/left-arrow-black.png";
import protectionbusiness from "../../../assets/images/protectionbusiness.png";
import publicprivatepartnership from "../../../assets/images/publicprivatepartnership.png";
import carbonfinance from "../../../assets/images/carbonfinance.png";
import cross from "../../../assets/images/cross.png";
import right from "../../../assets/images/right.png";
import inprogress from "../../../assets/images/inprogress.png";
import Accordion from "react-bootstrap/Accordion";
const BankableProjects = () => {
  return (
    <>
      <div className="projects">
        <div className="sky-topper">
          <div className="container mobile">
            <div className="custom-row">
              <a href="/Resilience">
                <img
                  src={leftarrowblack}
                  alt="back"
                  className="left-arrow-black"
                />
                <div className="back">Back</div>
              </a>
            </div>
            <div className="page-title">Bankable Projects</div>
          </div>
          <div className="container desktop">
            <div className="custom-row">
              <a href="/Resilience">
                <img
                  src={leftarrowblack}
                  alt="back"
                  className="left-arrow-black"
                />
                <div className="back">Back</div>
              </a>
              <div className="page-title">Bankable Projects</div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="title projects-title">
            Opportunity for development and private sector partners to support
            the LCARP
            <span> with a total of ~$3bn</span>
          </div>
          <div className="project-desc-title">How Can You Get Involved?</div>
          <div className="project-desc-desc">
            Fund <span>technical preparation</span> of Public-private
            partnerships arrangement
          </div>
          <div className="legends">
            <div>
              <img src={right} alt="right" className="cross-right" />
              <span>Completed</span>
            </div>
            <div>
              <img src={cross} alt="cross" className="cross-right" />
              <span>Not yet started</span>
            </div>
            <div>
              <img src={inprogress} alt="inprogress" className="cross-right" />
              <span>In progress</span>
            </div>
          </div>
          <div className="project-col mobile">
            <div className="project-row">
              <div className="project-desc-title">
                Waste Transfer Stations and Vehicles
              </div>
              <div className="project-desc-desc">
                Build <span>30 transfer stations</span> &amp; purchase waste
                collection vehicles to increase the state’s waste management
                capacity and reduce floodings due to clogged drainages
              </div>
            </div>
            <div className="investment">INVESTMENT: ~$2.5mn</div>
            <div className="project-row">
              <div className="project-desc-title">Landfills</div>
              <div className="project-desc-desc">
                <span>
                  Rehabilitate existing landfills and construct 3 new landfills
                </span>{" "}
                to increase the state’s waste management capacity and reduce
                flooding due to clogged drainages
              </div>
            </div>
            <div className="investment">INVESTMENT: ~$450mn</div>
            <div className="project-row">
              <div className="project-desc-title">Alternative Water Supply</div>
              <div className="project-desc-desc">
                Develop an{" "}
                <span>alternative water supply (1.3bn gallons per day)</span> to
                minimize ground water extraction and health impacts on saline
                water intrusion
              </div>
            </div>
            <div className="investment">INVESTMENT: ~$1bn</div>
            <div className="project-row">
              <div className="project-desc-title">Sewage Treatment Plant</div>
              <div className="project-desc-desc">
                <span>
                  Build a sewage treatment plant through collaboration
                </span>{" "}
                between Lagos water corporation and Lagos wastewater management
                office to minimize impacts of land subsidence
              </div>
            </div>
            <div className="investment">INVESTMENT: ~$275mn</div>
            <div className="project-row">
              <div className="project-desc-title">
                Commercial rainwater harvesting
              </div>
              <div className="project-desc-desc">
                Harvested rainwater can serve a large portion of their water
                needs, reducing flooding and water costs
              </div>
            </div>
            <div className="investment">INVESTMENT: ~$3mn</div>
            <div className="project-row">
              <div className="project-desc-title">
                Transport links (highways)
              </div>
              <div className="project-desc-desc">
                Construction and rehabilitation of{" "}
                <span>critical highways and interstate roads</span> to prevent
                flooding and damage from flooding
              </div>
            </div>
            <div className="investment">INVESTMENT: ~$270mn</div>
            <div className="project-row">
              <div className="project-desc-title">
                Transport links (waterways)
              </div>
              <div className="project-desc-desc">
                Construction & rehabilitation of{" "}
                <span>critical waterways including ~26 jetties</span> and docks
                inundated to create resilient transport channels
              </div>
            </div>
            <div className="investment">INVESTMENT: ~$300mn</div>
            <div className="project-row">
              <div className="project-desc-title">Floodproofing Assets</div>
              <div className="project-desc-desc">
                Floodproofing of <span>42 affected power assets</span> (power
                grid and power substations) and{" "}
                <span>44 affected communication assets</span> (Communication
                mast)
              </div>
            </div>
            <div className="investment">INVESTMENT: $4mn</div>
            <div className="project-row">
              <div className="project-desc-title">
                Disease surveillance and sanitation solutions
              </div>
              <div className="project-desc-desc">
                <span>Implement surveillance systems</span> for existing and new
                disease risks addressing heat and water-related disease
              </div>
            </div>
            <div className="investment">INVESTMENT: ~$50mn</div>
            <div className="project-row">
              <div className="project-desc-title">Early warning systems</div>
              <div className="project-desc-desc">
                Systems to alert residents about{" "}
                <span>imminent weather events</span>, including flooding,
                enabling timely actions
              </div>
            </div>
            <div className="investment">INVESTMENT: ~$20mn</div>
            <div className="project-row">
              <div className="project-desc-title">
                Flood resistant low-income housing
              </div>
              <div className="project-desc-desc">
                Build flood-resistant housing complexes, ensuring safety for
                residents and continuous rent collection during flood events
              </div>
            </div>
            <div className="investment">INVESTMENT: ~$275mn</div>
            <div className="project-row">
              <div className="project-desc-title">
                Regenerative agriculture/agroforestry
              </div>
              <div className="project-desc-desc">
                Convert under-used Lagos State agricultural lands into{" "}
                <span>water sinks</span> with the creation of natural
                floodplains
              </div>
            </div>
            <div className="investment">INVESTMENT: ~$7mn</div>
            <div className="project-row">
              <div className="project-desc-title">Aquafarming Facilities</div>
              <div className="project-desc-desc">
                Create aquaculture facilities resilient to flooding, turning a
                problem into a <span>solution and generating income</span> from
                the sale of fish and seafood
              </div>
            </div>
            <div className="investment">INVESTMENT: ~$50mn</div>

            <div className="project-row">
              <div className="project-desc-title">Mangrove Restoration</div>
              <div className="project-desc-desc">
                Restore <span>116-ha of mangrove across 5 LGAs</span> as a
                nature-based solution to the impacts of sea level rise
              </div>
            </div>
            <div className="investment">INVESTMENT: ~$25mn</div>
          </div>
          <table className="desktop">
            <thead>
              <tr>
                <td>Project Name</td>
                <td>Investment</td>
                <td>Design Study</td>
                <td>Implementation</td>
                <td>Next Steps</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <div className="project-row">
                    <div className="project-desc-title">
                      Waste Transfer Stations and Vehicles
                    </div>
                    <div className="project-desc-desc">
                      Build <span>30 transfer stations</span> &amp; purchase
                      waste collection vehicles to increase the state’s waste
                      management capacity and reduce floodings due to clogged
                      drainages
                    </div>
                  </div>
                </td>
                <td>
                  <div className="investment">~$2.5mn</div>
                </td>
                <td className="cross-td">
                  <img src={right} alt="cross" className="cross-right" />
                </td>
                <td className="cross-td">
                  <img src={inprogress} alt="cross" className="cross-right" />
                </td>
                <td>Feasibility</td>
              </tr>
              <tr>
                <td>
                  <div className="project-row">
                    <div className="project-desc-title">Landfills</div>
                    <div className="project-desc-desc">
                      <span>
                        Rehabilitate existing landfills and construct 3 new
                        landfills
                      </span>{" "}
                      to increase the state’s waste management capacity and
                      reduce flooding due to clogged drainages
                    </div>
                  </div>
                </td>
                <td>
                  <div className="investment">~$450mn</div>
                </td>
                <td className="cross-td">
                  <img src={inprogress} alt="cross" className="cross-right" />
                </td>
                <td className="cross-td">
                  <img src={cross} alt="cross" className="cross-right" />
                </td>
                <td>Feasibility</td>
              </tr>
              <tr>
                <td>
                  <div className="project-row">
                    <div className="project-desc-title">
                      Alternative Water Supply
                    </div>
                    <div className="project-desc-desc">
                      Develop an{" "}
                      <span>
                        alternative water supply (1.3bn gallons per day)
                      </span>{" "}
                      to minimize ground water extraction and health impacts on
                      saline water intrusion
                    </div>
                  </div>
                </td>
                <td>
                  <div className="investment">~$1bn</div>
                </td>
                <td className="cross-td">
                  <img src={cross} alt="cross" className="cross-right" />
                </td>
                <td className="cross-td">
                  <img src={cross} alt="cross" className="cross-right" />
                </td>
                <td>Feasibility</td>
              </tr>
              <tr>
                <td>
                  <div className="project-row">
                    <div className="project-desc-title">
                      Sewage Treatment Plant
                    </div>
                    <div className="project-desc-desc">
                      <span>
                        Build a sewage treatment plant through collaboration
                      </span>{" "}
                      between Lagos water corporation and Lagos wastewater
                      management office to minimize impacts of land subsidence
                    </div>
                  </div>
                </td>
                <td>
                  <div className="investment">~$275mn</div>
                </td>
                <td className="cross-td">
                  <img src={inprogress} alt="cross" className="cross-right" />
                </td>
                <td className="cross-td">
                  <img src={cross} alt="cross" className="cross-right" />
                </td>
                <td>Feasibility</td>
              </tr>
              <tr>
                <td>
                  <div className="project-row">
                    <div className="project-desc-title">
                      Commercial rainwater harvesting
                    </div>
                    <div className="project-desc-desc">
                      Harvested rainwater can serve a large portion of their
                      water needs, reducing flooding and water costs
                    </div>
                  </div>
                </td>
                <td>
                  <div className="investment">~$3mn</div>
                </td>
                <td className="cross-td">
                  <img src={cross} alt="cross" className="cross-right" />
                </td>
                <td className="cross-td">
                  <img src={cross} alt="cross" className="cross-right" />
                </td>
                <td>Feasibility</td>
              </tr>
              <tr>
                <td>
                  <div className="project-row">
                    <div className="project-desc-title">
                      Transport links (highways)
                    </div>
                    <div className="project-desc-desc">
                      Construction and rehabilitation of{" "}
                      <span>critical highways and interstate roads</span> to
                      prevent flooding and damage from flooding
                    </div>
                  </div>
                </td>
                <td>
                  <div className="investment">~$270mn</div>
                </td>
                <td className="cross-td">
                  <img src={cross} alt="cross" className="cross-right" />
                </td>
                <td className="cross-td">
                  <img src={cross} alt="cross" className="cross-right" />
                </td>
                <td>Feasibility</td>
              </tr>
              <tr>
                <td>
                  <div className="project-row">
                    <div className="project-desc-title">
                      Transport links (waterways)
                    </div>
                    <div className="project-desc-desc">
                      Construction & rehabilitation of{" "}
                      <span>critical waterways including ~26 jetties</span> and
                      docks inundated to create resilient transport channels
                    </div>
                  </div>
                </td>
                <td>
                  <div className="investment">~$300mn</div>
                </td>
                <td className="cross-td">
                  <img src={right} alt="cross" className="cross-right" />
                </td>
                <td className="cross-td">
                  <img src={cross} alt="cross" className="cross-right" />
                </td>
                <td>Feasibility</td>
              </tr>
              <tr>
                <td>
                  <div className="project-row">
                    <div className="project-desc-title">
                      Floodproofing Assets
                    </div>
                    <div className="project-desc-desc">
                      Floodproofing of <span>42 affected power assets</span>{" "}
                      (power grid and power substations) and{" "}
                      <span>44 affected communication assets</span>{" "}
                      (Communication mast)
                    </div>
                  </div>
                </td>
                <td>
                  <div className="investment">$4mn</div>
                </td>
                <td className="cross-td">
                  <img src={cross} alt="cross" className="cross-right" />
                </td>
                <td className="cross-td">
                  <img src={cross} alt="cross" className="cross-right" />
                </td>
                <td>Feasibility</td>
              </tr>
              <tr>
                <td>
                  <div className="project-row">
                    <div className="project-desc-title">
                      Disease surveillance and sanitation solutions
                    </div>
                    <div className="project-desc-desc">
                      <span>Implement surveillance systems</span> for existing
                      and new disease risks addressing heat and water-related
                      disease
                    </div>
                  </div>
                </td>
                <td>
                  <div className="investment">~$50mn</div>
                </td>
                <td className="cross-td">
                  <img src={cross} alt="cross" className="cross-right" />
                </td>
                <td className="cross-td">
                  <img src={cross} alt="cross" className="cross-right" />
                </td>
                <td>Feasibility</td>
              </tr>
              <tr>
                <td>
                  <div className="project-row">
                    <div className="project-desc-title">
                      Early warning systems
                    </div>
                    <div className="project-desc-desc">
                      Systems to alert residents about{" "}
                      <span>imminent weather events</span>, including flooding,
                      enabling timely actions
                    </div>
                  </div>
                </td>
                <td>
                  <div className="investment">~$20mn</div>
                </td>
                <td className="cross-td">
                  <img src={cross} alt="cross" className="cross-right" />
                </td>
                <td className="cross-td">
                  <img src={cross} alt="cross" className="cross-right" />
                </td>
                <td>Feasibility</td>
              </tr>
              <tr>
                <td>
                  <div className="project-row">
                    <div className="project-desc-title">
                      Flood resistant low-income housing
                    </div>
                    <div className="project-desc-desc">
                      Build flood-resistant housing complexes, ensuring safety
                      for residents and continuous rent collection during flood
                      events
                    </div>
                  </div>
                </td>
                <td>
                  <div className="investment">~$275mn</div>
                </td>
                <td className="cross-td">
                  <img src={cross} alt="cross" className="cross-right" />
                </td>
                <td className="cross-td">
                  <img src={cross} alt="cross" className="cross-right" />
                </td>
                <td>Feasibility</td>
              </tr>
              <tr>
                <td>
                  <div className="project-row">
                    <div className="project-desc-title">
                      Regenerative agriculture/agroforestry
                    </div>
                    <div className="project-desc-desc">
                      Convert under-used Lagos State agricultural lands into{" "}
                      <span>water sinks</span> with the creation of natural
                      floodplains
                    </div>
                  </div>
                </td>
                <td>
                  <div className="investment">~$7mn</div>
                </td>
                <td className="cross-td">
                  <img src={cross} alt="cross" className="cross-right" />
                </td>
                <td className="cross-td">
                  <img src={cross} alt="cross" className="cross-right" />
                </td>
                <td>Feasibility</td>
              </tr>
              <tr>
                <td>
                  <div className="project-row">
                    <div className="project-desc-title">
                      Aquafarming Facilities
                    </div>
                    <div className="project-desc-desc">
                      Create aquaculture facilities resilient to flooding,
                      turning a problem into a{" "}
                      <span>solution and generating income</span> from the sale
                      of fish and seafood
                    </div>
                  </div>
                </td>
                <td>
                  <div className="investment">~$50mn</div>
                </td>
                <td className="cross-td">
                  <img src={cross} alt="cross" className="cross-right" />
                </td>
                <td className="cross-td">
                  <img src={cross} alt="cross" className="cross-right" />
                </td>
                <td>Feasibility</td>
              </tr>
              <tr>
                <td>
                  <div className="project-row">
                    <div className="project-desc-title">
                      Mangrove Restoration
                    </div>
                    <div className="project-desc-desc">
                      Restore <span>116-ha of mangrove across 5 LGAs</span> as a
                      nature-based solution to the impacts of sea level rise
                    </div>
                  </div>
                </td>
                <td>
                  <div className="investment">~$25mn</div>
                </td>
                <td className="cross-td">
                  <img src={cross} alt="cross" className="cross-right" />
                </td>
                <td className="cross-td">
                  <img src={cross} alt="cross" className="cross-right" />
                </td>
                <td>Feasibility</td>
              </tr>
            </tbody>
          </table>
          <div className="assumptions"></div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default BankableProjects;
